export const RETURN_CHANNEL = {
  ONLINE: {
    value: 'ONLINE',
    label: 'Online',
  },
  OFFLINE: {
    value: 'OFFLINE',
    label: 'Offline',
  },
};

export const APPROVED_SUB_STATUS = {
  WAITING_FOR_PICKUP: {
    value: 'WAITING_FOR_PICKUP',
    text: 'ordersReturn.status.waitingForPickup',
    color: '#0075FF',
    background: '#0075FF1A',
  },
  RETURNING: {
    value: 'RETURNING',
    text: 'ordersReturn.status.returning',
    color: '#6852D3',
    background: '#6852D31A',
  },
};

export const RETURN_STATUS = {
  AWAITING_APPROVAL: {
    value: 'AWAITING_APPROVAL',
    text: 'ordersReturn.status.awaitingApproval',
    color: '#FFB300',
    background: '#FFB3001A',
  },
  APPROVED: {
    value: 'APPROVED',
    text: 'ordersReturn.status.approved',
    color: '#0075FF',
    background: '#0075FF1A',
  },
  PASS_QC: {
    value: 'PASS_QC',
    text: 'ordersReturn.status.passedQC',
    color: '#FA541C',
    background: '#FA541C1A',
  },
  FAILED_QC: {
    value: 'FAILED_QC',
    text: 'ordersReturn.status.failedQC',
    color: '#AB2328',
    background: '#AB23281A',
  },
  COMPLETED: {
    value: 'COMPLETED',
    text: 'ordersReturn.status.completed',
    color: '#66C11F',
    background: '#66C11F1A',
  },
  CANCELLED: {
    value: 'CANCELLED',
    text: 'ordersReturn.status.canceled',
    color: '#848484',
    background: '#8484841A',
  },
  WAITING_FOR_REFUND: {
    value: 'WAITING_FOR_REFUND',
    text: 'ordersReturn.status.waitingForRefund',
    color: '#FFB300',
    background: '#FFB3001A',
  },
  PROCESSING_REFUND: {
    value: 'PROCESSING_REFUND',
    text: 'ordersReturn.status.processingRefund',
    color: '#FFB300',
    background: '#FFB3001A',
  },
};

export const RETURN_METHOD = {
  PICKUP: {
    value: 'PICKUP',
    text: 'ordersReturn.pickup',
  },
  DROP_OFF: {
    value: 'DROP_OFF',
    text: 'ordersReturn.dropOff',
  },
};

export const RETURN_SOLUTION = {
  //  RETURN_ORDER: {
  //    value: 'RETURN_ORDER',
  //    text: 'ordersReturn.solutions.returnReplace',
  //  },
  REFUND: {
    value: 'REFUND',
    text: 'ordersReturn.solutions.returnRefund',
  },
  ISSUE_VOUCHER: {
    value: 'ISSUE_VOUCHER',
    text: 'ordersReturn.solutions.issueVoucher',
  },
};

export const WHO_PAY_SHIPPING_FEE = {
  CUSTOMER: {
    value: 'CUSTOMER',
    text: 'ordersReturn.customer',
  },
  ROUTINE: {
    value: 'ROUTINE',
    text: 'Routine',
  },
};

export const FAILED_QC_REASON = {
  WRONG_PRODUCT: {
    value: 'WRONG_PRODUCT',
    label: 'ordersReturn.failedQCReason.wrongProduct',
  },
  BROKEN_PRODUCT: {
    value: 'BROKEN_PRODUCT',
    label: 'ordersReturn.failedQCReason.brokenProduct',
  },
  NOT_SIMILAR: {
    value: 'NOT_SIMILAR',
    label: 'ordersReturn.failedQCReason.notSimilarToTakingPictures',
  },
  USED_TO: {
    value: 'USED_TO',
    label: 'ordersReturn.failedQCReason.used',
  },
  UNBOXED: {
    value: 'UNBOXED',
    label: 'ordersReturn.failedQCReason.unboxed',
  },
  OTHER: {
    value: 'OTHER',
    label: 'ordersReturn.failedQCReason.other',
  },
};

export const RETURN_REASON = {
  //  ITEM_MISSING: {
  //    value: 'ITEM_MISSING',
  //    text: 'ordersReturn.returnReason.itemMissing',
  //  },
  //  INCORRECT_ITEM_SHIPPED: {
  //    value: 'INCORRECT_ITEM_SHIPPED',
  //    text: 'ordersReturn.returnReason.incorrectItemShipped',
  //  },
  //  DIFFERENT_DESCRIPTION: {
  //    value: 'DIFFERENT_DESCRIPTION',
  //    text: 'ordersReturn.returnReason.differentDescription',
  //  },
  //  FUNCTIONAL_DMG: {
  //    value: 'FUNCTIONAL_DMG',
  //    text: 'ordersReturn.returnReason.functionalDmg',
  //  },
  //  TOO_LONG_SHIP: {
  //    value: 'TOO_LONG_SHIP',
  //    text: 'ordersReturn.returnReason.tooLongShip',
  //  },
  //  OTHER: {
  //    value: 'OTHER',
  //    text: 'ordersReturn.returnReason.other',
  //  },

  ITEM_MISSING: {
    value: 'ITEM_MISSING',
    text: 'ordersReturn.returnReason.itemMissing',
  },
  INCORRECT_ITEM_SHIPPED: {
    value: 'INCORRECT_ITEM_SHIPPED',
    text: 'ordersReturn.returnReason.incorrectItemShipped',
  },
  DIFFERENT_DESCRIPTION: {
    value: 'DIFFERENT_DESCRIPTION',
    text: 'ordersReturn.returnReason.differentDescription',
  },
  FUNCTIONAL_DMG: {
    value: 'FUNCTIONAL_DMG',
    text: 'ordersReturn.returnReason.functionalDmg',
  },
  EXCHANGE_SIZE: {
    value: 'EXCHANGE_SIZE',
    text: 'ordersReturn.returnReason.exchangeSize',
  },
  DIFFERENT_MODEL: {
    value: 'DIFFERENT_MODEL',
    text: 'ordersReturn.returnReason.differentModel',
  },
  NO_LONGER_NEEDED: {
    value: 'NO_LONGER_NEEDED',
    text: 'ordersReturn.returnReason.noLongerNeeded',
  },
};

export const CANCEL_REASON = {
  OVER_DUE_SUPPORT: {
    value: 'OVER_DUE_SUPPORT',
    text: 'ordersReturn.cancelReason.overDueSP',
  },
  PRODUCT_WRONG: {
    value: 'PRODUCT_WRONG',
    text: 'ordersReturn.cancelReason.productWrong',
  },
  PRODUCT_EXPIRY: {
    value: 'PRODUCT_EXPIRY',
    text: 'ordersReturn.cancelReason.productExpiry',
  },
  DISCOUNTED_OVER_30_PERCENT: {
    value: 'DISCOUNTED_OVER_30_PERCENT',
    text: 'ordersReturn.cancelReason.discountedPercent',
  },
  AGREEMENT_WITH_BUYER: {
    value: 'AGREEMENT_WITH_BUYER',
    text: 'ordersReturn.cancelReason.agreement',
  },
  UNCLEAR_REASON: {
    value: 'UNCLEAR_REASON',
    text: 'ordersReturn.cancelReason.unclearReason',
  },
  CORRECT_PRODUCT_SENT: {
    value: 'CORRECT_PRODUCT_SENT',
    text: 'ordersReturn.cancelReason.correctProduct',
  },
  OTHER: {
    value: 'OTHER',
    text: 'ordersReturn.cancelReason.other',
  },
};

export const RETURN_REFUND_STATUS = {
  REFUND_PROCESSING: 'REFUND_PROCESSING',
  REFUND_FAILED: 'REFUND_FAILED',
  REFUND_SUCCESS: 'REFUND_SUCCESS',
};
